import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 *
 * The shadowDom / Intersection Observer version of Paul's concept:
 * https://github.com/paulirish/lite-youtube-embed
 *
 * A lightweight YouTube embed. Still should feel the same to the user, just
 * MUCH faster to initialize and paint.
 *
 * Thx to these as the inspiration
 *   https://storage.googleapis.com/amp-vs-non-amp/youtube-lazy.html
 *   https://autoplay-youtube-player.glitch.me/
 *
 * Once built it, I also found these (👍👍):
 *   https://github.com/ampproject/amphtml/blob/master/extensions/amp-youtube
 *   https://github.com/Daugilas/lazyYT https://github.com/vb/lazyframe
 */
export var LiteYTEmbed = /*#__PURE__*/function (_HTMLElement) {
  _inherits(LiteYTEmbed, _HTMLElement);

  var _super = _createSuper(LiteYTEmbed);

  function LiteYTEmbed() {
    var _this;

    _classCallCheck(this, LiteYTEmbed);

    _this = _super.call(this);
    _this.iframeLoaded = false;

    _this.setupDom();

    return _this;
  }

  _createClass(LiteYTEmbed, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;

      this.addEventListener('pointerover', LiteYTEmbed.warmConnections, {
        once: true
      });
      this.addEventListener('click', function () {
        return _this2.addIframe();
      });
    }
  }, {
    key: "videoId",
    get: function get() {
      return encodeURIComponent(this.getAttribute('videoid') || '');
    },
    set: function set(id) {
      this.setAttribute('videoid', id);
    }
  }, {
    key: "videoTitle",
    get: function get() {
      return this.getAttribute('videotitle') || 'Video';
    },
    set: function set(title) {
      this.setAttribute('videotitle', title);
    }
  }, {
    key: "videoPlay",
    get: function get() {
      return this.getAttribute('videoPlay') || 'Play';
    },
    set: function set(name) {
      this.setAttribute('videoPlay', name);
    }
  }, {
    key: "videoStartAt",
    get: function get() {
      return Number(this.getAttribute('videoStartAt') || '0');
    },
    set: function set(time) {
      this.setAttribute('videoStartAt', String(time));
    }
  }, {
    key: "autoLoad",
    get: function get() {
      return this.hasAttribute('autoload');
    },
    set: function set(value) {
      if (value) {
        this.setAttribute('autoload', '');
      } else {
        this.removeAttribute('autoload');
      }
    }
  }, {
    key: "params",
    get: function get() {
      return "start=".concat(this.videoStartAt, "&").concat(this.getAttribute('params'));
    }
    /**
     * Define our shadowDOM for the component
     */

  }, {
    key: "setupDom",
    value: function setupDom() {
      var shadowDom = this.attachShadow({
        mode: 'open'
      });
      shadowDom.innerHTML = "\n      <style>\n        :host {\n          contain: content;\n          display: block;\n          position: relative;\n          width: 100%;\n          padding-bottom: calc(100% / (16 / 9));\n        }\n\n        #frame, #fallbackPlaceholder, iframe {\n          position: absolute;\n          width: 100%;\n          height: 100%;\n        }\n\n        #frame {\n          cursor: pointer;\n        }\n\n        #fallbackPlaceholder {\n          object-fit: cover;\n        }\n\n        #frame::before {\n          content: '';\n          display: block;\n          position: absolute;\n          top: 0;\n          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAADGCAYAAAAT+OqFAAAAdklEQVQoz42QQQ7AIAgEF/T/D+kbq/RWAlnQyyazA4aoAB4FsBSA/bFjuF1EOL7VbrIrBuusmrt4ZZORfb6ehbWdnRHEIiITaEUKa5EJqUakRSaEYBJSCY2dEstQY7AuxahwXFrvZmWl2rh4JZ07z9dLtesfNj5q0FU3A5ObbwAAAABJRU5ErkJggg==);\n          background-position: top;\n          background-repeat: repeat-x;\n          height: 60px;\n          padding-bottom: 50px;\n          width: 100%;\n          transition: all 0.2s cubic-bezier(0, 0, 0.2, 1);\n          z-index: 1;\n        }\n        /* play button */\n        .lty-playbtn {\n          width: 70px;\n          height: 46px;\n          background-color: #212121;\n          z-index: 1;\n          opacity: 0.8;\n          border-radius: 14%; /* TODO: Consider replacing this with YT's actual svg. Eh. */\n          transition: all 0.2s cubic-bezier(0, 0, 0.2, 1);\n          border: 0;\n        }\n        #frame:hover .lty-playbtn {\n          background-color: #f00;\n          opacity: 1;\n        }\n        /* play button triangle */\n        .lty-playbtn:before {\n          content: '';\n          border-style: solid;\n          border-width: 11px 0 11px 19px;\n          border-color: transparent transparent transparent #fff;\n        }\n        .lty-playbtn,\n        .lty-playbtn:before {\n          position: absolute;\n          top: 50%;\n          left: 50%;\n          transform: translate3d(-50%, -50%, 0);\n        }\n\n        /* Post-click styles */\n        .lyt-activated {\n          cursor: unset;\n        }\n\n        #frame.lyt-activated::before,\n        .lyt-activated .lty-playbtn {\n          display: none;\n        }\n      </style>\n      <div id=\"frame\">\n        <picture>\n          <source id=\"webpPlaceholder\" type=\"image/webp\">\n          <source id=\"jpegPlaceholder\" type=\"image/jpeg\">\n          <img id=\"fallbackPlaceholder\" referrerpolicy=\"origin\">\n        </picture>\n        <button class=\"lty-playbtn\"></button>\n      </div>\n    ";
      this.domRefFrame = this.shadowRoot.querySelector('#frame');
      this.domRefImg = {
        fallback: this.shadowRoot.querySelector('#fallbackPlaceholder'),
        webp: this.shadowRoot.querySelector('#webpPlaceholder'),
        jpeg: this.shadowRoot.querySelector('#jpegPlaceholder')
      };
      this.domRefPlayButton = this.shadowRoot.querySelector('.lty-playbtn');
    }
    /**
     * Parse our attributes and fire up some placeholders
     */

  }, {
    key: "setupComponent",
    value: function setupComponent() {
      this.initImagePlaceholder();
      this.domRefPlayButton.setAttribute('aria-label', "".concat(this.videoPlay, ": ").concat(this.videoTitle));
      this.setAttribute('title', "".concat(this.videoPlay, ": ").concat(this.videoTitle));

      if (this.autoLoad) {
        this.initIntersectionObserver();
      }
    }
    /**
     * Lifecycle method that we use to listen for attribute changes to period
     * @param {*} name
     * @param {*} oldVal
     * @param {*} newVal
     */

  }, {
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(name, oldVal, newVal) {
      switch (name) {
        case 'videoid':
          {
            if (oldVal !== newVal) {
              this.setupComponent(); // if we have a previous iframe, remove it and the activated class

              if (this.domRefFrame.classList.contains('lyt-activated')) {
                this.domRefFrame.classList.remove('lyt-activated');
                this.shadowRoot.querySelector('iframe').remove();
                this.iframeLoaded = false;
              }
            }

            break;
          }

        default:
          break;
      }
    }
    /**
     * Inject the iframe into the component body
     */

  }, {
    key: "addIframe",
    value: function addIframe() {
      if (!this.iframeLoaded) {
        var iframeHTML = "\n<iframe frameborder=\"0\"\n  allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen\n  src=\"https://www.youtube.com/embed/".concat(this.videoId, "?autoplay=1&").concat(this.params, "\"\n></iframe>");
        this.domRefFrame.insertAdjacentHTML('beforeend', iframeHTML);
        this.domRefFrame.classList.add('lyt-activated');
        this.iframeLoaded = true;
      }
    }
    /**
     * Setup the placeholder image for the component
     */

  }, {
    key: "initImagePlaceholder",
    value: function initImagePlaceholder() {
      // we don't know which image type to preload, so warm the connection
      LiteYTEmbed.addPrefetch('preconnect', 'https://i.ytimg.com/');
      var posterUrlWebp = "https://i.ytimg.com/vi_webp/".concat(this.videoId, "/hqdefault.webp");
      var posterUrlJpeg = "https://i.ytimg.com/vi/".concat(this.videoId, "/hqdefault.jpg");
      this.domRefImg.webp.srcset = posterUrlWebp;
      this.domRefImg.jpeg.srcset = posterUrlJpeg;
      this.domRefImg.fallback.src = posterUrlJpeg;
      this.domRefImg.fallback.setAttribute('aria-label', "".concat(this.videoPlay, ": ").concat(this.videoTitle));
      this.domRefImg.fallback.setAttribute('alt', "".concat(this.videoPlay, ": ").concat(this.videoTitle));
    }
    /**
     * Setup the Intersection Observer to load the iframe when scrolled into view
     */

  }, {
    key: "initIntersectionObserver",
    value: function initIntersectionObserver() {
      var _this3 = this;

      if ('IntersectionObserver' in window && 'IntersectionObserverEntry' in window) {
        var options = {
          root: null,
          rootMargin: '0px',
          threshold: 0
        };
        var observer = new IntersectionObserver(function (entries, observer) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && !_this3.iframeLoaded) {
              LiteYTEmbed.warmConnections();

              _this3.addIframe();

              observer.unobserve(_this3);
            }
          });
        }, options);
        observer.observe(this);
      }
    }
    /**
     * Add a <link rel={preload | preconnect} ...> to the head
     * @param {*} kind
     * @param {*} url
     * @param {*} as
     */

  }], [{
    key: "observedAttributes",
    get: function get() {
      return ['videoid'];
    }
  }, {
    key: "addPrefetch",
    value: function addPrefetch(kind, url, as) {
      var linkElem = document.createElement('link');
      linkElem.rel = kind;
      linkElem.href = url;

      if (as) {
        linkElem.as = as;
      }

      linkElem.crossOrigin = 'true';
      document.head.append(linkElem);
    }
    /**
     * Begin preconnecting to warm up the iframe load Since the embed's netwok
     * requests load within its iframe, preload/prefetch'ing them outside the
     * iframe will only cause double-downloads. So, the best we can do is warm up
     * a few connections to origins that are in the critical path.
     *
     * Maybe `<link rel=preload as=document>` would work, but it's unsupported:
     * http://crbug.com/593267 But TBH, I don't think it'll happen soon with Site
     * Isolation and split caches adding serious complexity.
     */

  }, {
    key: "warmConnections",
    value: function warmConnections() {
      if (LiteYTEmbed.preconnected) return; // Host that YT uses to serve JS needed by player, per amp-youtube

      LiteYTEmbed.addPrefetch('preconnect', 'https://s.ytimg.com'); // The iframe document and most of its subresources come right off
      // youtube.com

      LiteYTEmbed.addPrefetch('preconnect', 'https://www.youtube.com'); // The botguard script is fetched off from google.com

      LiteYTEmbed.addPrefetch('preconnect', 'https://www.google.com'); // TODO: Not certain if these ad related domains are in the critical path.
      // Could verify with domain-specific throttling.

      LiteYTEmbed.addPrefetch('preconnect', 'https://googleads.g.doubleclick.net');
      LiteYTEmbed.addPrefetch('preconnect', 'https://static.doubleclick.net');
      LiteYTEmbed.preconnected = true;
    }
  }]);

  return LiteYTEmbed;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
LiteYTEmbed.preconnected = false; // Register custom element

customElements.define('lite-youtube', LiteYTEmbed);